import { FormBuilder, ReactiveFormsModule, Validators } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { CommonModule } from "@angular/common";
import { Component, inject, signal } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { SessionService } from "../_services";

@Component({
  imports: [ReactiveFormsModule, RouterModule, CommonModule],
  selector: "hawk-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  host: {
    class: "app-page",
  },
})
export class LoginComponent {
  private sessionService: SessionService = inject(SessionService);
  private fb = inject(FormBuilder);

  protected form = this.fb.group({
    email: this.fb.control({ value: "", disabled: false }, [Validators.required]),
    password: this.fb.control({ value: "", disabled: false }, [Validators.required]),
  });
  protected error = signal<string>("");
  protected returnUrl = inject(ActivatedRoute).snapshot.queryParams.returnUrl || "/";

  public async onSubmit() {
    const form = this.form.value;

    await this.sessionService.loginRedirect(form.email, form.password, this.returnUrl);
    if (this.sessionService.loginError) {
      this.error.set(this.sessionService.loginError);
    } else {
      this.error = null;
    }
  }
}
